<template>
  <div class="index">
    <!-- banner -->
    <slider :sliderData="sliderData"></slider>
    <!-- 无图新闻（学院新闻+通知公告） -->
    <div class="wutuDiv">
      <div class="w1200">
        <xydt
          :xydtList="xydtList"
          moreLink="/list.html?HType=2&CId=6584"
        ></xydt>
      </div>
    </div>
    <div class="wutuDiv1">
      <div class="w1200 flexDiv">
        <tzgg
          :tzggList="tzggList"
          moreLink="/list.html?HType=2&CId=6278"
        ></tzgg>
        <!-- <xsjl
          :xsjlList="xsjlList"
          moreLink="/list.html?HType=2&CId=6279"
        ></xsjl> -->
      </div>
    </div>
    <!-- 无图新闻（教学动态+学生快讯） -->
    <div class="wutuDiv2">
      <div class="w1200">
        <cgzs
          :cgzsList="cgzsList"
          moreLink="/list.html?HType=2&CId=6282"
        ></cgzs>
        <div class="Listtong-home">
          <div class="kslj">
            <div class="top_text">
              <p>快速链接</p>
              <span>QUICK LINKS</span>
            </div>
          </div>
          <div class="kstd_img">
            <a href="http://jku.1w1w.com:8116/portal/#/login" target="_blank">
              <img src="../assets/img/kyglxt.png" alt="" />
            </a>
            <!-- <a href="javascript:;" target="_blank">
              <img src="../assets/img/bslc.png" alt="" />
            </a> -->
            <a href="list.html?HType=4&CId=6286">
              <img src="../assets/img/xzzx.png" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../assets/css/index.css";
import "../assets/js/init.js";
import "../assets/js/wow.js";
import slider from "@/components/slider";
import xydt from "@/components/xydt";
import tzgg from "@/components/tzgg";
import xsjl from "@/components/xsjl";
import cgzs from "@/components/cgzs";
export default {
  name: "index",
  components: {
    slider,
    xydt,
    tzgg,
    xsjl,
    cgzs
  },
  data() {
    return {
      baseUrl: "this.baseUrl",
      sliderData: [],
      xydtList: [],
      tzggList: [],
      xsjlList: [],
      cgzsList: []
    };
  },
  created() {
    this.$root.$children["0"].$children["0"].menuListOne.forEach(
      element => (element.On = false)
    );
    this.sliderData = this.Base.GetFilesInfoByCid(6287, 1, "", 6, 1); //banner
    this.xydtList = this.Base.GetNewsInfoByCid(6584, false, 1, "", 5); //新闻动态
    this.tzggList = this.Base.GetNewsInfoByCid(6278, false, 1, "", 5); //通知公告
    this.xsjlList = this.Base.GetNewsInfoByCid(6279, false, 1, "", 5); //学术交流
    this.cgzsList = this.Base.GetNewsInfoByCid(6282, false, 1, "", 4); //成果展示
  }
};
</script>
<style lang="less" scoped>
.Listtong-home {
  .kslj {
    width: 1200px;
    height: 110px;
    background-color: #f9f9f9;
    padding-top: 40px;
    box-sizing: border-box;
    margin-bottom: 38px;
    .top_text {
      position: relative;
      padding-left: 40px;
      &::before {
        content: "";
        position: absolute;
        width: 2px;
        height: 100%;
        background-color: #32454f;
        left: 30px;
      }
      p {
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
        line-height: 20px;
        letter-spacing: 2px;
        color: #32454f;
        margin-bottom: 10px;
      }
      span {
        display: block;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 20px;
        letter-spacing: 0px;
        color: #32454f;
      }
    }
  }
  .kstd_img {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    // justify-content: center;
    a {
      display: block;
      width: 270px;
      height: 70px;
      background-color: #ebf8ff;
      border-radius: 4px;
      margin-right: 40px;
      img {
        object-fit: cover;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue